// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Password_buttonWrapper__1InpP"};